<div class="flex justify-content-center w-full">
    <h1>Please wait while we process your authentication...</h1>
</div>